import { Component, OnInit, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { I18nService } from '../../../../../shared/services/i18n.service';

interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [CommonModule, AccordionModule, TranslatePipe],
  templateUrl: './faq-section.html',
  styleUrl: './faq-section.scss'
})
export class FaqSection implements OnInit {
  questions: FaqItem[] = [];
  private faqKeys = [
    'landing.faq.q1',
    'landing.faq.q2',
    'landing.faq.q3',
    'landing.faq.q4',
    'landing.faq.q5',
    'landing.faq.q6'
  ];

  private translate = inject(TranslateService);
  private i18nService = inject(I18nService);

  constructor() {
    // Reload when language changes using I18nService signal
    effect(() => {
      const lang = this.i18nService.languageChanged();
      if (lang) {
        this.loadFaqItems();
      }
    });
  }

  ngOnInit(): void {
    this.loadFaqItems();
  }

  private loadFaqItems(): void {
    this.questions = this.faqKeys.map((key) => ({
      question: this.translate.instant(`${key}.question`),
      answer: this.translate.instant(`${key}.answer`)
    }));
  }
}
